'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record2;

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignmentV2MessageMetadata = function (_Record) {
  _inherits(AssignmentV2MessageMetadata, _Record);

  function AssignmentV2MessageMetadata() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AssignmentV2MessageMetadata);

    var auditParameters = properties.get('auditParameters');
    return _possibleConstructorReturn(this, (AssignmentV2MessageMetadata.__proto__ || Object.getPrototypeOf(AssignmentV2MessageMetadata)).call(this, properties.merge(auditParameters)));
  }

  return AssignmentV2MessageMetadata;
}((0, _immutable.Record)((_Record2 = {}, _defineProperty(_Record2, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.ASSIGNMENT_V2), _defineProperty(_Record2, 'assignedAgent', {
  agentId: null,
  agentType: null
}), _defineProperty(_Record2, 'assignedByMethod', null), _defineProperty(_Record2, 'assignedByAgentType', null), _defineProperty(_Record2, 'assignedByAgentId', null), _defineProperty(_Record2, 'agentId', null), _defineProperty(_Record2, 'agentType', null), _defineProperty(_Record2, 'method', null), _defineProperty(_Record2, 'auditTimestamp', null), _defineProperty(_Record2, 'unassignedAgent', {
  agentId: null,
  agentType: null
}), _Record2), 'AssignmentV2MessageMetadata'));

exports.default = AssignmentV2MessageMetadata;
module.exports = exports['default'];